export enum ThirdPartyDetailsTabIndex {
  Messages = 0,
  ShipmentBasics = 1,
}
